/* import __COLOCATED_TEMPLATE__ from './custom-action-dependent-background-workflows-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();